<template>
  <div style="text-align:center; margin-top:4rem;">
    <h1>Error 404</h1>
    <h2>No está autorizado para ver esta página</h2>
    <button @click="$router.push('/')"
      style="margin-top:2rem; padding:0.7rem 2rem; font-size:1rem; background:#2F5597; color:white; border:none; border-radius:5px; cursor:pointer;">
      Regresar al inicio
    </button>
  </div>
</template>